<template>
  <div class="frame">
    <h3>{{$t('Webportal.CX.Margin.MarginHelpTitle')}}</h3>
    <p>{{$t('Webportal.CX.Margin.MarginHelpText1')}}</p>

    <table class="table table-bordered">
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="true" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
        <td>{{ $t('Webportal.CX.Margin.Accomplished') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange"/></td>
        <td>{{ $t('Webportal.CX.Margin.Failed') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="null" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
        <td>{{ $t('Webportal.CX.Margin.NoData') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :InHealingPeriod="true" :IsCurrentWave="true" :IsHealingDeactivated="false" :Accomplished="false" :HealingStatus="''" :ColorRange="colorRange" :AvailableHealings="1"/></td>
        <td>{{ $t('Webportal.CX.Margin.HealingPossible') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="'in_progress'" :InHealingPeriod="false" :IsCurrentWave="true" :ColorRange="colorRange"/></td>
        <td>{{ $t('Webportal.CX.Margin.HealingInProgress') }}</td>
      </tr>
    </table>

    <p>{{$t('Webportal.CX.Margin.MarginHelpText2')}}</p>
    <p>{{$t('Webportal.CX.Margin.MarginHelpText3')}}</p>
    <p>{{$t('Webportal.CX.Margin.MarginHelpText4')}}</p>

    <h5>{{ $t('Webportal.CX.Margin.FAQResultsReleaseHeadline') }}</h5>
    <ul>
      <li>{{ $t('Webportal.CX.Margin.Q1ResultsRelease') }}</li>
      <li>{{ $t('Webportal.CX.Margin.Q2ResultsRelease') }}</li>
      <li>{{ $t('Webportal.CX.Margin.Q3ResultsRelease') }}</li>
      <li>{{ $t('Webportal.CX.Margin.Q4ResultsRelease') }}</li>
    </ul>
  </div>
</template>

<script>
import MarginKpiStatusIndicator from "@/components/CX/MarginKpiStatusIndicator.vue"

export default {
  components: {
    MarginKpiStatusIndicator
  },

  props: {
    colorRange: Array
  }
}
</script>

<style scoped>
.frame {
  margin: 1rem;
}
</style>